module.exports = __webpack_public_path__ + "img/add-bank.3419b990.jpg";